import { CircularProgress } from "@mui/material";
import React from "react";

export const LoadingSpinner = () => {
  return (
    <div className="text-center mt-8">
      <CircularProgress />
    </div>
  );
};
